exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hideHelper {\n    height: 0;\n    overflow: hidden;\n}\n.vselect .vs__dropdown-menu {\n    max-height: 200px;\n}\n.ti-autocomplete {\n    max-height: 160px;\n    overflow: scroll;\n}\n\n", ""]);

// exports
